import seedrandom from "seedrandom";

export const YJMALL_BASE_TIME = Date.UTC(2026, 4, 20, 9, 0, 0);
export const DEFAULT_SEED = "yjmall-redesign-p0";

export class SeededRuntime {
  private rng: seedrandom.PRNG;

  constructor(
    readonly seed = DEFAULT_SEED,
    private cursor = 0,
    readonly baseTime = YJMALL_BASE_TIME,
  ) {
    this.rng = seedrandom(seed);
    for (let i = 0; i < cursor; i += 1) this.rng();
  }

  random() {
    this.cursor += 1;
    return this.rng();
  }

  int(min: number, max: number) {
    return Math.floor(this.random() * (max - min + 1)) + min;
  }

  float(min: number, max: number, precision = 2) {
    const value = min + this.random() * (max - min);
    return Number(value.toFixed(precision));
  }

  pick<T>(items: readonly T[]) {
    return items[this.int(0, items.length - 1)];
  }

  now(offsetMs = 0) {
    return this.baseTime + offsetMs;
  }

  latencyMs() {
    return this.int(150, 500);
  }

  fork(suffix: string) {
    return new SeededRuntime(`${this.seed}:${suffix}`, 0, this.baseTime);
  }
}

export function createSeededRuntime(seed = DEFAULT_SEED) {
  return new SeededRuntime(seed);
}

export function wait(ms: number) {
  return new Promise<void>((resolve) => {
    window.setTimeout(resolve, ms);
  });
}
